/*
 * File: AsanaProjectDetails.tsx
 * Project: a-a
 * File Created: Friday, 25th April 2025 7:34:21 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Friday, 13th June 2025 9:12:06 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import {
  Badge,
  Box,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Radio,
  Select,
  SelectChangeEvent,
  Skeleton,
  Switch,
  Typography,
  useTheme,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import zeplinColor from '../../../../theme/Color';
import AsanaTable from '../AsanaTable/AsanaTable';
import { LightTooltip } from '../../../shared/CustomTooltip/CustomTooltip';
import CustomButton from '../../../shared/CustomButton/CustomButton';
import CustomPopOver from '../../../shared/CustomPopOver/CustomPopOver';
import AsanaCard from '../AsanaCard/AsanaCard';
import CustomOverlapImg from '../../../shared/CustomOverlapImg/CustomOverlapImg';
import AsanaProjectTable from '../AsanaProjectTable/AsanaProjectTable';
import { AsanaService } from '../../../../service/asana.service';
import AsanaTaskCard from '../AsanaTaskCard/AsanaTaskCard';
import { DndContext, DragOverlay, useDroppable } from '@dnd-kit/core';
import { arrayMove, useSortable } from '@dnd-kit/sortable';
import CustomAlert from '../../../shared/CustomAlert/CustomAlert';
import CustomAlertContain from '../../../shared/CustomAlert/CustomAlertContain';
import { CSS } from '@dnd-kit/utilities';
import AsanaDnd from '../AsanaDnD/AsanaDnd';
import AsanaAddProject from '../AsanaAddProject/AsanaAddProject';
import CustomModal from '../../../shared/CustomModal/CustomModal';
import CustomCard from '../../../shared/CustomCard/CustomCard';
import AsanaAddTask from '../AsanaAddTask/AsanaAddTask';
import CustomAutocomplete from '../../../shared/CustomAutocomplete/CustomAutocomplete';
import CustomCheckbox from '../../../shared/CustomCheckbox/CustomCheckbox';
import { Constants } from '../../../../utilities/constants';
import CustomTextField from '../../../shared/CustomTextField/CustomTextField';
import { useInput } from '../../../../customHook/useInput';
import validator from 'validator';
type Response = {
  projectId: string;
  projectName: string;
  updatedDate: string;
  projectLink: string;
  tasksGrouped: { sectionId: ''; sectionName: ''; tasks: any[] }[];
};
const MenuProps = {
  PaperProps: {
    sx: {
      borderRadius: '14px',
      // padding: '16px',
    },
  },
};

const AsanaProjectDetails = () => {
  const location = useLocation();
  const selectedProject = location?.state?.selectedProject;
  // const asanaTaskDeleted = sessionStorage.getItem('delete-asana-task');
  const {
    handleChange: handleMemberChange,
    handleBlur: handleMemberBlur,
    // clearInput: clearMember,
    value: member,
    invalid: invalidMember,
    didChange: didMemberChange,
    setValue: setMember,
    // setDidChange: setDidMemberChange,
  } = useInput('', validator.isEmail);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [message, setMessage] = useState('');
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const theme = useTheme();
  const navigate = useNavigate();
  const [layout, setLayout] = useState<'column' | 'row'>('column');
  const [clientList, setClientList] = useState([]);
  const [taskGrouped, setTaskGrouped] = useState<Response>({
    projectId: '',
    projectName: '',
    updatedDate: '',
    projectLink: '',
    tasksGrouped: [],
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<boolean | any>();
  const [anchorEl, setAnchorEl] = React.useState<HTMLDivElement | null>(null);
  const [access, setAccess] = useState('project-admin');
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const [priority, setPriority] = useState<any>();
  const [status, setStatus] = useState<any>();
  const [createdBy, setCreatedBy] = useState(['']);
  const [assignee, setAssignee] = useState<any>();
  const [overdueFilter, setOverdueFilter] = useState(false);
  const [drawerState, setDrawerState] = useState(false);
  const [selectedItems, setSelectedItems] = useState<{
    priority: string[];
    status: string[];
    created_by: string[];
    assignee: string[];
  }>({
    priority: [],
    status: [],
    created_by: [],
    assignee: [],
  });
  const [copy, setCopy] = useState('');
  const [anchorElProject, setAnchorElProject] = React.useState<HTMLDivElement | null>(null);
  const [editedProject, setEditedProject] = useState<any>();
  const [modalTaskOpen, setModalTaskOpen] = React.useState(false);
  const [addMemberModal, setAddMemberModal] = useState(false);
  const openProject = Boolean(anchorElProject);
  const idProject = openProject ? 'simple-popover' : undefined;
  const handleClickProject = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorElProject(event.currentTarget);
  };

  const handleEdit = () => {
    setAnchorElProject(null);
    setModalOpen(true);
  };
  const handleCopyLink = (val: any) => {
    navigator.clipboard.writeText(val);
    setCopy('Link copied');
    setAnchorElProject(null);
  };

  const ID = location.pathname.split('/')[2];
  const getTaskBySection = async (clear?: boolean, deleteTask?: boolean) => {
    try {
      setLoading(true);
      const res = clear
        ? await AsanaService.getAsanaTasksBySection(ID, {})
        : await AsanaService.getAsanaTasksBySection(ID, {
            ...(selectedItems?.assignee?.length && {
              assignee: selectedItems?.assignee?.map((item) => item),
            }),
            ...(selectedItems?.priority?.length && {
              priority: selectedItems?.priority?.map((item) => item),
            }),
            ...(selectedItems?.status?.length && {
              status: selectedItems?.status?.map((item) => item),
            }),
            ...(selectedItems?.created_by?.length && {
              created_by: selectedItems?.created_by?.map((item) => item),
            }),
            ...(overdueFilter && { overdue: true }),
          });
      setPriority(res?.fieldOptions?.priority?.options);
      setStatus(res?.fieldOptions?.status?.options);
      setTaskGrouped(res as Response);
      if (clear) {
        setSelectedItems({
          priority: [],
          status: [],
          created_by: [],
          assignee: [],
        });
        setOverdueFilter(false);
      }
      if (deleteTask) {
        setMessage('Deleted task successfully');
        // sessionStorage.removeItem('delete-asana-task');
      }
    } catch (err: any) {
      // console.log({ err });
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  const getFilterOptions = async () => {
    try {
      const res = await AsanaService.taskFilterOption(ID);

      setCreatedBy(res.createdBy);
      // setPriority(res.priorities);
      // setStatus(res.statuses);
    } catch (err: any) {
      console.log(err);

      setError(err);
    }
  };
  const getFilter = async () => {
    try {
      const res = await AsanaService.getAsanaFilter();
      setAssignee(res.members);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    getFilterOptions();
    getFilter();
  }, []);
  useEffect(() => {
    getTaskBySection();
  }, [layout]);
  useEffect(() => {
    !modalTaskOpen && !drawerState && getTaskBySection();
  }, [modalTaskOpen, drawerState]);
  // const { setNodeRef } = useDroppable({ id: 'droppable' });

  const handleClearAll = () => {
    getTaskBySection(true);
    setOverdueFilter(false);
    setSelectedItems({
      priority: [],
      status: [],
      created_by: [],
      assignee: [],
    });
    //  getTask(false, true);
    setAnchorEl(null);
  };
  const handleSelection = (item: any, type: string) => {
    const key = type as keyof typeof selectedItems;

    const {
      target: { value },
    } = item;

    setSelectedItems({
      ...selectedItems,
      [key]: typeof value === 'string' ? value.split(',') : value,
    });
  };
  const handleTaskFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
    setOverdueFilter(e.target.checked);
  };
  const applyFilter = () => {
    getTaskBySection();
    setAnchorEl(null);
  };
  const handleChangeAccess = (event: SelectChangeEvent) => {
    setAccess(event.target.value as string);
  };

  const alertMessage = (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 12 }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          // backgroundColor: !error ? zeplinColor.Success : '',
          borderRadius: '60px',
          padding: '3px',
        }}
      >
        <img src='/assets/checkmark-green.png' width={24} height={24} />
      </div>
      <Typography variant='body2' style={{ color: zeplinColor.Neutral1 }}>
        {copy}
      </Typography>
    </div>
  );
  const handleClose = () => {
    setCopy('');
    setError(undefined);
    setMessage('');
  };
  const handleDeleteClose = () => {
    setOpenDeleteModal(false);
  };
  const handleDeleteClick = async () => {
    try {
      await AsanaService.deleteAsanaProject(selectedProject?.id);
      navigate('/asana');
      sessionStorage.setItem('delete-project', 'true');
    } catch (err) {
      setMessage('Something went wrong');
    }
  };

  const handleCloseAddMember = () => {
    setAddMemberModal(false);
  };
  const handleInvite = async () => {
    try {
      const res = await AsanaService.inviteMembers(taskGrouped?.projectId, member);
      console.log(res);
      setMessage('Member invited successfully');
      setMember('');
    } catch (err) {
      setError(err);
    }
  };
  return (
    <>
      <Divider component='div' sx={{ borderColor: zeplinColor.Neutral5, position: 'relative' }} />
      <Box sx={{ padding: '24px 24px 0px 24px' }}>
        <Box
          sx={{
            display: 'flex',
            // flexDirection: 'column',
            // gap: '24px',
            justifyContent: 'space-between',
            marginTop: '10px',
            position: 'relative',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              // flexDirection: 'column',
              // gap: '24px',
              alignItems: 'flex-start',
              justifyContent: 'space-between',
              gap: '16px',
              position: 'relative',
            }}
          >
            <img
              src={`/assets/deal-blue.png`}
              width='48px'
              height='48px'
              //   onClick={() => setLayout('column')}
              style={{ cursor: 'pointer' }}
            />
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                // gap: '8px',
                justifyContent: 'flex-start',
                // justifyContent: 'space-between',
                // gap: '16px',
                position: 'relative',
              }}
            >
              {loading ? (
                <Skeleton
                  variant='text'
                  sx={{
                    fontSize: theme.typography.body2,
                    flex: 1,
                    width: '100px',
                    // Optionally adjust other styles here
                  }}
                />
              ) : editedProject?.name?.length < 50 || taskGrouped?.projectName?.length < 50 ? (
                <Typography variant='heading1'>
                  {editedProject?.name
                    ? editedProject?.name?.slice(0, 50)
                    : taskGrouped?.projectName?.slice(0, 50)}
                </Typography>
              ) : (
                <LightTooltip
                  title={
                    <Typography variant='body3' color={zeplinColor.Neutral1}>
                      {editedProject?.name ? editedProject?.name : taskGrouped?.projectName}
                    </Typography>
                  }
                  placement='bottom-end'
                  style={{ backgroundColor: zeplinColor.BasicBlack, borderRadius: '8px' }}
                >
                  <Typography variant='heading1'>
                    {editedProject?.name
                      ? editedProject?.name?.slice(0, 50)
                      : taskGrouped?.projectName?.slice(0, 50)}
                    {editedProject?.name
                      ? editedProject?.name?.length > 50
                        ? '...'
                        : ''
                      : taskGrouped?.projectName?.length > 50
                      ? '...'
                      : ''}
                  </Typography>
                </LightTooltip>
              )}
              {loading ? (
                <Skeleton
                  variant='text'
                  sx={{
                    fontSize: theme.typography.body2,
                    flex: 1,
                    width: '100px',
                    // Optionally adjust other styles here
                  }}
                />
              ) : (
                <Typography variant='label1' color={zeplinColor.Neutral8}>
                  Last updated on{' '}
                  {taskGrouped?.updatedDate
                    ? new Date(taskGrouped?.updatedDate)
                        .toLocaleString('en-GB', {
                          day: '2-digit',
                          month: 'short',
                          year: 'numeric',
                        })
                        .replace(/(\s)(\w{3})(\s)(\d{4})/, '$1$2, $4')
                    : 'NA'}
                  -
                  {taskGrouped?.updatedDate
                    ? new Date(taskGrouped?.updatedDate).toLocaleString('en-GB', {
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: true,
                      })
                    : ''}
                </Typography>
              )}
            </Box>
            <img
              width={'18px'}
              height={'18px'}
              src={'/assets/vertical-dots.svg'}
              alt='options-icon'
              onClick={(e) => {
                handleClickProject(e);
              }}
              aria-hidden='false'
              style={{ marginTop: '0.3rem' }}
              // style={{ imageRendering: 'pixelated', filter: 'blur(0px)' }}
            />
          </Box>
          <CustomPopOver
            setAnchorEl={setAnchorElProject}
            anchorEl={anchorElProject}
            id={idProject}
            sx={{ borderRadius: '14px', boxShadow: 'rgba(0, 0, 0, 0.15)' }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
                padding: '16px',
              }}
            >
              {/* <a
                href={'test'}
                target='_blank'
                rel='noopener noreferrer'
                style={{ textDecoration: 'none' }}
              >
                <Box sx={{ display: 'flex', gap: '9px', cursor: 'pointer' }}>
                  <img src={'/assets/view.svg'} width={18} height={18} />
                  <Typography variant='body3' color={zeplinColor.BasicBlack}>
                    View details
                  </Typography>
                </Box>
              </a> */}

              <Box sx={{ display: 'flex', gap: '9px', cursor: 'pointer' }} onClick={handleEdit}>
                <img src={'/assets/edit.svg'} width={18} height={18} />
                <Typography variant='body3' color={zeplinColor.BasicBlack}>
                  Edit project
                </Typography>
              </Box>
              {/* <Box sx={{ display: 'flex', gap: '9px', cursor: 'pointer' }}>
                <Box
                  sx={{
                    width: '15px',
                    height: '15px',
                    backgroundColor: zeplinColor.Blue5,
                    borderRadius: '5px',
                  }}
                ></Box>
                <Typography variant='body3' color={zeplinColor.BasicBlack}>
                  Set color & icon
                </Typography>
              </Box> */}
              <Box
                sx={{ display: 'flex', gap: '9px', cursor: 'pointer' }}
                onClick={() => handleCopyLink(taskGrouped?.projectLink)}
              >
                <img src={'/assets/copy-link.svg'} width={18} height={18} />
                <Typography variant='body3' color={zeplinColor.BasicBlack}>
                  Copy link
                </Typography>
              </Box>

              <Box
                sx={{ display: 'flex', gap: '9px', cursor: 'pointer' }}
                onClick={(e) => {
                  setOpenDeleteModal(true);
                  setAnchorElProject(null);
                }}
              >
                <img src={'/assets/delete-red.png'} width={18} height={18} />
                <Typography variant='body3' color={zeplinColor.Error}>
                  Delete
                </Typography>
              </Box>
            </Box>
          </CustomPopOver>
          <Box
            sx={{
              display: 'flex',
              // flexDirection: 'column',
              gap: '4px',
              // justifyContent: 'space-between',
              // marginTop: '10px',
              position: 'relative',
              alignItems: 'center',
            }}
          >
            <CustomOverlapImg
              images={assignee?.map((val: any) => val?.photo)}
              name={assignee?.map((val: any) => val?.name)}
            />
            <img
              src={`/assets/add-members.png`}
              width='32px'
              height='32px'
              alt='add-members'
              style={{ cursor: 'pointer' }}
              onClick={() => {
                setAddMemberModal(true);
              }}
            />
          </Box>
          <CustomModal handleClose={handleCloseAddMember} open={addMemberModal}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
              }}
            >
              <CustomCard
                styles={{
                  borderRadius: '14px',

                  backgroundColor: zeplinColor.Neutral1,
                  overflowY: 'hidden',
                  width: '631px',
                  height: '521px',
                  boxShadow: 'rgba(0, 0, 0, 0.15)',
                  // display: 'flex',
                  // flexDirection: 'column',
                  // justifyContent: 'space-between',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundColor: zeplinColor.Neutral1,
                    zIndex: 1,
                    // gap: '49px',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      padding: '24px',
                      position: 'sticky',
                      top: 0,
                      backgroundColor: zeplinColor.Neutral1,
                      zIndex: 1000,
                    }}
                  >
                    <Typography variant='heading2'>
                      {editedProject?.name
                        ? editedProject?.name?.slice(0, 50)
                        : taskGrouped?.projectName?.slice(0, 50)}
                    </Typography>
                    <Box
                      sx={{
                        display: 'flex',
                        gap: '12px',
                      }}
                    >
                      {' '}
                      <img
                        src={'/assets/copy-view.png'}
                        width={'24px'}
                        height={'24px'}
                        alt='copy'
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleCopyLink(taskGrouped?.projectLink)}
                      />
                      <img
                        src={'/assets/close-icon.svg'}
                        width={24}
                        height={24}
                        alt='close'
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          setAddMemberModal(false);
                          setMember('');
                        }}
                      />
                    </Box>
                  </Box>
                  <Divider
                    component='div'
                    sx={{ borderColor: zeplinColor.Neutral5, position: 'sticky', top: '78px' }}
                  />
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '32px',
                      padding: '24px',
                    }}
                  >
                    {' '}
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '32px',
                        overflow: 'hidden',
                        position: 'sticky',
                        top: '102px',
                        backgroundColor: zeplinColor.Neutral1,
                        zIndex: 1,
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          gap: '12px',
                          paddingTop: '10px',
                        }}
                      >
                        <Box
                          sx={{
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '12px',
                          }}
                        >
                          <Box
                            sx={{
                              flex: 1,
                              display: 'flex',
                              flexDirection: 'column',
                              gap: '12px',
                            }}
                          >
                            {/* <CustomAutocomplete
                              required={true}
                              options={[]}
                              getOptionLabel={(option: any) => option}
                              label={'Editor'}
                              handleDeleteItems={() => {}}
                              // selectedItems={}
                              handleSelection={(value: any) => {
                                handleSelection(value, 'assignTo');
                              }}
                              value={[]}
                              handleFilter={() => {}}
                              placeholder='Search people'
                              currentLength={[]?.length}
                              totalLength={[]?.length}
                              next={() => {}}
                              multiple={false}
                            /> */}
                            <CustomTextField
                              style={{ width: '100%' }}
                              onBlur={handleMemberBlur}
                              onChange={handleMemberChange}
                              name='Member'
                              text={member}
                              error={invalidMember && member ? 'Please enter valid email' : ''}
                              label={'Member'}
                              type='text'
                              tabindex={1}
                              // required
                            />
                          </Box>
                          {/* <CustomCheckbox label='Notify when tasks are added to the project' /> */}
                        </Box>

                        <CustomButton
                          disabled={(invalidMember && member) || !member || loading ? true : false}
                          onClick={handleInvite}
                          variant='contained'
                          color={'primary'}
                          style={{
                            borderRadius: '14px',
                            width: '105px',
                            height: 56,
                            // width: '100%',
                            '&.Mui-focusVisible': { backgroundColor: '#333CAA' },
                          }}
                          textStyle={{
                            color: zeplinColor.Neutral1,
                          }}
                          text={'Invite'}
                          // tabindex={4}
                        />
                      </Box>

                      {/* <Box
                        sx={{
                          flex: 1,
                        }}
                      >
                        
                        <FormControl sx={{ width: '100%' }}>
                          <InputLabel id='demo-simple-select-label'>Access</InputLabel>
                          <Select
                            // labelId='demo-simple-select-label'
                            // id='demo-simple-select'
                            value={access}
                            label='Access'
                            onChange={handleChangeAccess}
                            IconComponent={(props) => (
                              <img
                                src={'/assets/down-arrow.svg'}
                                width={20}
                                height={20}
                                {...props}
                              />
                            )}
                            sx={{ width: '100%' }}
                          >
                            {Constants.privacyOptions.map((val) => (
                              <MenuItem value={val?.value}>{val?.label}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Box> */}
                    </Box>
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '16px',
                      }}
                    >
                      <Typography variant='heading4'>Members</Typography>
                      <Box
                        sx={{
                          overflowY: 'scroll',
                          height: '270px',
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '16px',
                        }}
                      >
                        {assignee?.map((val: any) => (
                          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Box
                              sx={{
                                display: 'flex',
                                // flexDirection: 'column',
                                alignItems: 'center',
                                gap: '8px',
                                // alignSelf: 'stretch',
                                cursor: 'pointer',
                              }}
                              onClick={() => {}}
                            >
                              <Box
                                sx={{
                                  borderRadius: '100px',
                                  // padding: '10px',
                                  width: '26px',
                                  height: '26px',
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  backgroundColor: zeplinColor.Neutral8,
                                }}
                              >
                                <img
                                  src={'/assets/no-assignee.png'}
                                  width={'26px'}
                                  height={'26px'}
                                  style={{ borderRadius: '100px', objectFit: 'cover' }}
                                  alt='no-assignee-photo'
                                />
                              </Box>
                              <Box
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  justifyContent: 'space-between',
                                }}
                              >
                                <Typography variant='body2'>{val?.name}</Typography>
                                <Typography variant='body3' color={zeplinColor.Neutral9}>
                                  {val?.name}
                                </Typography>
                              </Box>
                            </Box>
                            {/* <CustomAutocomplete
                            required={true}
                            options={[]}
                            getOptionLabel={(option: any) => option}
                            label={'Editor'}
                            handleDeleteItems={() => {}}
                            // selectedItems={}
                            handleSelection={(value: any) => {
                              handleSelection(value, 'assignTo');
                            }}
                            value={[]}
                            handleFilter={() => {}}
                            placeholder='Search people'
                            currentLength={[]?.length}
                            totalLength={[]?.length}
                            next={() => {}}
                            multiple={false}
                            border={true}
                          /> */}
                            {/* <FormControl>
                              <InputLabel id='demo-simple-select-label'></InputLabel>
                              <Select
                                labelId='demo-simple-select-label'
                                id='demo-simple-select'
                                value={access}
                                label='Age'
                                onChange={handleChangeAccess}
                                IconComponent={(props) => (
                                  <img
                                    src={'/assets/down-arrow.svg'}
                                    width={20}
                                    height={20}
                                    {...props}
                                  />
                                )}
                                sx={{ '.MuiOutlinedInput-notchedOutline': { border: 'none' } }}
                              >
                                <MenuItem value={'project-admin'}>Project Admin</MenuItem>
                                <MenuItem value={'editor'}>Editor</MenuItem>
                              </Select>
                            </FormControl> */}
                          </Box>
                        ))}
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </CustomCard>
              {/* {loading ? <CustomLoader /> : ''} */}
            </Box>
          </CustomModal>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '24px',
            marginTop: '30px',
            position: 'relative',
          }}
        >
          <Typography variant='heading3'>Tasks</Typography>{' '}
          {taskGrouped?.tasksGrouped?.filter((val) => val?.tasks?.length)?.length <= 0 ? (
            ''
          ) : (
            <Box
              sx={{
                position: 'absolute',
                top: '-1.2rem',
                right: '0rem',
                display: 'flex',
                gap: '16px',
                // width: '595px',
              }}
            >
              {/* <CustomSearch /> */}
              {/* <Box
            sx={{
              borderRadius: '100px',
              border: `1px solid ${zeplinColor.Neutral6}`,
              padding: '10px',
              width: '48px',
              height: '48px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: zeplinColor.Neutral1,
            }}
          >
            <img src={`/assets/sort-icon.svg`} width='20px' height='20px' />
          </Box> */}
              <Badge
                badgeContent={Object.values(selectedItems).reduce(
                  (prev, val) => (val?.length ? prev + 1 : prev),
                  overdueFilter ? 1 : 0,
                )}
                color='primary'
                sx={{ '.MuiBadge-badge': { top: '0.7rem', right: '0.2rem' } }}
              >
                <LightTooltip
                  title={
                    <Typography variant='body3' color={zeplinColor.Neutral1}>
                      Filter
                    </Typography>
                  }
                  placement='bottom-end'
                  style={{ backgroundColor: zeplinColor.BasicBlack, borderRadius: '8px' }}
                  // sx={{ [`& .${tooltipClasses.tooltip}`]: { backgroundColor: zeplinColor.Neutral1 } }}
                >
                  <Box
                    sx={{
                      borderRadius: '50px',
                      width: '48px',
                      height: '48px',
                      border: `1px solid ${zeplinColor.Neutral6}`,
                      // p: '0px 10px',
                      backgroundColor: zeplinColor.Neutral1,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      cursor: 'pointer',
                    }}
                    onClick={(e) => handleClick(e)}
                  >
                    <img src={'/assets/filter.svg'} width={20} height={20} />
                  </Box>
                </LightTooltip>
              </Badge>
              <Box
                sx={{
                  borderRadius: '50px',
                  border: `1px solid ${zeplinColor.Neutral6}`,
                  padding: '6px',
                  width: '92px',
                  height: '48px',
                  display: 'flex',
                  justifyContent: 'space-around',
                  alignItems: 'center',
                  gap: '10px',
                  backgroundColor: zeplinColor.Neutral1,
                  flex: 1,
                }}
              >
                {layout === 'column' ? (
                  <img
                    src={`/assets/selected-col-layout.svg`}
                    width='36px'
                    height='36px'
                    onClick={() => setLayout('column')}
                    style={{ cursor: 'pointer' }}
                  />
                ) : (
                  <img
                    src={`/assets/column-layout-icon.svg`}
                    width='20px'
                    height='20px'
                    onClick={() => setLayout('column')}
                    style={{ cursor: 'pointer' }}
                  />
                )}
                {layout === 'row' ? (
                  <img
                    src={`/assets/selected-row-layout.svg`}
                    width='36px'
                    height='36px'
                    onClick={() => setLayout('row')}
                    style={{ cursor: 'pointer' }}
                  />
                ) : (
                  <img
                    src={`/assets/row-layout-icon.svg`}
                    width='20px'
                    height='20px'
                    onClick={() => setLayout('row')}
                    style={{ cursor: 'pointer' }}
                  />
                )}
              </Box>
              <LightTooltip
                title={
                  <Typography variant='body3' color={zeplinColor.Neutral1}>
                    New task
                  </Typography>
                }
                placement='bottom-end'
                style={{ backgroundColor: zeplinColor.BasicBlack, borderRadius: '8px' }}
                // sx={{ [`& .${tooltipClasses.tooltip}`]: { backgroundColor: zeplinColor.Neutral1 } }}
              >
                <Box sx={{ width: '100%' }}>
                  <CustomButton
                    disabled={false}
                    onClick={() => {
                      setModalTaskOpen(true);
                    }}
                    variant='contained'
                    color={'primary'}
                    style={{
                      width: '100%',
                      borderRadius: '14px',
                      height: 48,
                      padding: '14px 16px',
                      '&.Mui-focusVisible': { backgroundColor: '#333CAA' },
                    }}
                    textStyle={{ color: zeplinColor.Neutral1 }}
                    text={'New Task'}
                    icon={<img src={`/assets/add-white.svg`} width={'13.3px'} height={'13.3px'} />}
                    // tabindex={4}
                  />
                </Box>
              </LightTooltip>
            </Box>
          )}
          <CustomPopOver
            setAnchorEl={setAnchorEl}
            anchorEl={anchorEl}
            id={id}
            sx={{
              borderRadius: '14px',
              boxShadow: 'rgba(0, 0, 0, 0.15)',
              marginTop: '8px',
              marginRight: '2rem',
              marginLeft: '-4rem',
            }}
          >
            <Box
              sx={{
                padding: '16px',
                width: '283px',
                height: '30rem',
                display: 'flex',
                flexDirection: 'column',
                gap: '24px',
              }}
            >
              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant='heading3' color={zeplinColor.BasicBlack}>
                  Filter
                </Typography>
                <Typography
                  variant='buttonSmall'
                  color={
                    Object.values(selectedItems).every((val) => val.length <= 0) && !overdueFilter
                      ? zeplinColor.Neutral8
                      : zeplinColor.Brand1
                  }
                  onClick={
                    Object.values(selectedItems).every((val) => val.length <= 0) && !overdueFilter
                      ? () => {}
                      : handleClearAll
                  }
                  sx={{
                    cursor:
                      Object.values(selectedItems).every((val) => val.length <= 0) && !overdueFilter
                        ? 'default'
                        : 'pointer',
                  }}
                >
                  Clear All
                </Typography>
              </Box>
              {/* <div> */}
              <FormGroup
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '16px',
                }}
              >
                <FormControl sx={{ width: '100%' }}>
                  <InputLabel
                    id='demo-multiple-name-label'
                    sx={{
                      '&.Mui-focused': { color: zeplinColor.Neutral9 },
                    }}
                  >
                    Assignee
                  </InputLabel>
                  <Select
                    labelId='demo-multiple-name-label'
                    id='demo-multiple-name'
                    multiple
                    value={selectedItems.assignee}
                    onChange={(e) => handleSelection(e, 'assignee')}
                    input={
                      <OutlinedInput
                        sx={{
                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderWidth: '1px',
                            color: zeplinColor.Neutral9,
                            borderColor: zeplinColor.Neutral9,
                          },
                          // paddingLeft: '16px',
                          padding: '0px 14px',
                        }}
                        label='Assignee'
                      />
                    }
                    renderValue={(selected) =>
                      assignee
                        ?.filter((val: any) => selected?.includes(val?.id))
                        ?.map((val: any) => val?.name)
                        .join(', ')
                    }
                    MenuProps={MenuProps}
                    IconComponent={() => (
                      <img src='/assets/down-arrow.svg' width='24px' height='24px' />
                    )}
                  >
                    {assignee?.map((name: any) => (
                      <MenuItem key={name?.id} value={name?.id}>
                        <Checkbox
                          checked={selectedItems.assignee.indexOf(name?.id) > -1}
                          sx={{
                            color: zeplinColor.BasicBlack,
                            '&.Mui-checked': {
                              color: zeplinColor.BasicBlack,
                            },
                          }}
                        />
                        {name?.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl sx={{ width: '100%' }}>
                  <InputLabel
                    id='demo-multiple-name-label'
                    sx={{
                      '&.Mui-focused': { color: zeplinColor.Neutral9 },
                    }}
                  >
                    Created by
                  </InputLabel>
                  <Select
                    labelId='demo-multiple-name-label'
                    id='demo-multiple-name'
                    multiple
                    value={selectedItems.created_by}
                    onChange={(e) => handleSelection(e, 'created_by')}
                    input={
                      <OutlinedInput
                        sx={{
                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderWidth: '1px',
                            color: zeplinColor.Neutral9,
                            borderColor: zeplinColor.Neutral9,
                          },
                          // paddingLeft: '16px',
                          padding: '0px 14px',
                        }}
                        label='Created by'
                      />
                    }
                    renderValue={(selected) => (selected as string[]).join(', ')}
                    MenuProps={MenuProps}
                    IconComponent={() => (
                      <img src='/assets/down-arrow.svg' width='24px' height='24px' />
                    )}
                  >
                    {createdBy.map((name) => (
                      <MenuItem key={name} value={name}>
                        <Checkbox
                          checked={selectedItems.created_by.indexOf(name) > -1}
                          sx={{
                            color: zeplinColor.BasicBlack,
                            '&.Mui-checked': {
                              color: zeplinColor.BasicBlack,
                            },
                          }}
                        />
                        {name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl sx={{ width: '100%' }}>
                  <InputLabel
                    id='demo-multiple-name-label'
                    sx={{
                      '&.Mui-focused': { color: zeplinColor.Neutral9 },
                    }}
                  >
                    Priority
                  </InputLabel>
                  <Select
                    labelId='demo-multiple-name-label'
                    id='demo-multiple-name'
                    multiple
                    value={selectedItems.priority}
                    onChange={(e) => handleSelection(e, 'priority')}
                    input={
                      <OutlinedInput
                        sx={{
                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderWidth: '1px',
                            color: zeplinColor.Neutral9,
                            borderColor: zeplinColor.Neutral9,
                          },
                          // paddingLeft: '16px',
                          padding: '0px 14px',
                        }}
                        label='Priority'
                      />
                    }
                    renderValue={(selected) =>
                      priority.filter((val: any) => val?.value === selected[0])[0]?.label
                    }
                    MenuProps={MenuProps}
                    IconComponent={() => (
                      <img src='/assets/down-arrow.svg' width='24px' height='24px' />
                    )}
                  >
                    {priority?.map((name: any) => (
                      <MenuItem key={name?.value} value={name?.value}>
                        <Checkbox
                          checked={selectedItems.priority.indexOf(name?.value) > -1}
                          sx={{
                            color: zeplinColor.BasicBlack,
                            '&.Mui-checked': {
                              color: zeplinColor.BasicBlack,
                            },
                          }}
                        />
                        {name?.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <FormControl sx={{ width: '100%' }}>
                  <InputLabel
                    id='demo-multiple-name-label'
                    sx={{
                      '&.Mui-focused': { color: zeplinColor.Neutral9 },
                    }}
                  >
                    Status
                  </InputLabel>
                  <Select
                    labelId='demo-multiple-name-label'
                    id='demo-multiple-name'
                    // multiple
                    value={selectedItems.status}
                    onChange={(e) => handleSelection(e, 'status')}
                    input={
                      <OutlinedInput
                        sx={{
                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderWidth: '1px',
                            color: zeplinColor.Neutral9,
                            borderColor: zeplinColor.Neutral9,
                          },
                          padding: '0px 14px',
                        }}
                        label='Status'
                      />
                    }
                    IconComponent={() => (
                      <img src='/assets/down-arrow.svg' width='24px' height='24px' />
                    )}
                    renderValue={(selected) =>
                      status.filter((val: any) => val?.value === selected[0])[0]?.label
                    }
                    MenuProps={MenuProps}
                  >
                    {status?.map((name: any) => (
                      <MenuItem key={name?.value} value={name?.value}>
                        <Radio
                          checked={selectedItems.status[0] === name?.value} // Check if this radio should be selected
                          sx={{
                            color: zeplinColor.BasicBlack,
                            '&.Mui-checked': {
                              color: zeplinColor.BasicBlack,
                            },
                          }}
                        />
                        {name?.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl sx={{ width: '100%' }}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={overdueFilter}
                        // defaultChecked
                        onChange={handleTaskFilter}
                        sx={{
                          width: '51px', // Track width
                          height: '31px', // Track height
                          padding: 0, // Remove internal padding for correct thumb alignment
                          '& .MuiSwitch-switchBase': {
                            padding: '1px 0px ',
                            // display: 'flex',
                            // justifyContent: 'center',
                            // alignItems: 'center',
                            margin: '2px',
                            transitionDuration: '300ms',
                            '&.Mui-checked': {
                              transform: 'translateX(20px)', // Thumb moves 20px to the right when checked
                              color: zeplinColor.Blue, // Thumb color
                              '& + .MuiSwitch-track': {
                                backgroundColor: zeplinColor.BasicBlack, // Track color when the switch is on
                                opacity: 1, // Full opacity when on
                                border: 0,
                              },
                            },
                            '&.Mui-focusVisible .MuiSwitch-thumb': {
                              color: zeplinColor.Neutral9, // Color for thumb when focused
                              border: '1px solid #fff', // Focus border
                            },
                            '&.Mui-disabled .MuiSwitch-thumb': {
                              color: '#D3D3D3', // Disabled thumb color (light gray)
                            },
                            '&.Mui-disabled + .MuiSwitch-track': {
                              opacity: 0.7, // Track opacity when disabled
                            },
                          },
                          '& .MuiSwitch-thumb': {
                            boxSizing: 'border-box',
                            width: '25px', // Thumb width
                            height: '25px', // Thumb height
                            backgroundColor: zeplinColor.Neutral1, // Thumb color
                          },
                          '& .MuiSwitch-track': {
                            borderRadius: '100px', // Border radius for the off state (left side rounded)
                            backgroundColor: zeplinColor.Neutral5, // Track color when off
                            opacity: 0.6, // Track opacity when off
                            transition: 'background-color 300ms ease', // Smooth transition when toggling
                          },
                        }}
                      />
                    }
                    label='Overdue task'
                    labelPlacement='start'
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      marginLeft: 0,
                      width: '100%',
                    }}
                  />
                </FormControl>
                <Box sx={{ display: 'flex', alignItems: 'flex-end', flex: 1 }}>
                  <CustomButton
                    onClick={applyFilter}
                    variant='contained'
                    disabled={
                      Object.values(selectedItems).every((val) => val.length <= 0) && !overdueFilter
                    }
                    color={'primary'}
                    style={{ width: '100%', borderRadius: 14, height: 56 }}
                    textStyle={{
                      color:
                        Object.values(selectedItems).every((val) => val.length <= 0) &&
                        !overdueFilter
                          ? zeplinColor.Neutral8
                          : zeplinColor.Neutral1,
                    }}
                    text={'Apply'}
                  />
                </Box>
              </FormGroup>
            </Box>
          </CustomPopOver>
          <Box sx={{ height: '100%' }}>
            {layout === 'column' ? (
              <AsanaDnd
                loading={loading}
                data={taskGrouped}
                key={taskGrouped?.projectId}
                setModalOpen={setModalTaskOpen}
                assignee={assignee}
                getTaskBySection={getTaskBySection}
                drawerState={drawerState}
                setDrawerState={setDrawerState}
                filter={
                  Object.values(selectedItems).reduce(
                    (prev, val) => (val?.length ? prev + 1 : prev),
                    overdueFilter ? 1 : 0,
                  ) > 0
                }
              />
            ) : (
              //  <DndContext
              //   onDragStart={handleDragStart}
              //   onDragEnd={handleDragEnd}
              //   onDragOver={handleDragOver}
              // >
              //   <Box
              //     sx={{
              //       display: 'grid',
              //       gridTemplateColumns: `repeat(${
              //         loading ? 3 : taskGrouped?.tasksGrouped?.length
              //       }, 1fr)`,
              //       gap: '16px',
              //       overflowY: 'scroll',
              //       height: '100vh',
              //       paddingBottom: '20rem',
              //     }}
              //   >
              //     {loading ? (
              //       [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((item, key) => (
              //         <AsanaTaskCard
              //           item={{
              //             assignee: '',
              //             assigneePhoto: '',
              //             dueDate: '',
              //             id: '',
              //             priority: '',
              //             priorityColor: '',
              //             status: '',
              //             statusColor: '',
              //             title: '',
              //           }}
              //           loading={true}
              //           key={id}
              //           id={key.toString()}
              //         />
              //       ))
              //     ) : taskGrouped?.tasksGrouped?.length ? (
              //       taskGrouped?.tasksGrouped?.map(
              //         (val) => val && <DragCol id={val?.sectionName} val={val} />,
              //       )
              //     ) : (
              //       <Box
              //         sx={{
              //           display: 'flex',
              //           flexDirection: 'column',
              //           justifyContent: 'center',
              //           alignItems: 'center',
              //           gap: '32px',
              //           flex: 1,
              //           height: '100vh',
              //           marginTop: '-10rem',
              //           // height: screenHeight > 640 ? '54vh' : screenHeight > 500 ? '41vh' : '39vh',
              //           // height: '100vh',
              //           // paddingBottom: '30%',
              //           // overflow: 'hidden',
              //         }}
              //       >
              //         <Box
              //           sx={{
              //             display: 'flex',
              //             flexDirection: 'column',
              //             justifyContent: 'center',
              //             alignItems: 'center',
              //             gap: '24px',
              //             // flex: 1,
              //             // height: screenHeight > 640 ? '54vh' : screenHeight > 500 ? '41vh' : '39vh',
              //           }}
              //         >
              //           {' '}
              //           <img src={'/assets/no-tasks.svg'} width={48} height={48} />
              //           <Box
              //             sx={{
              //               display: 'flex',
              //               flexDirection: 'column',
              //               justifyContent: 'center',
              //               alignItems: 'center',
              //               gap: '12px',
              //               // flex: 1,
              //               // height: screenHeight > 640 ? '54vh' : screenHeight > 500 ? '41vh' : '39vh',
              //             }}
              //           >
              //             <Typography variant='heading3' color={zeplinColor.BasicBlack} sx={{}}>
              //               No Tasks Yet
              //             </Typography>
              //             <Typography
              //               variant='body3'
              //               color={zeplinColor.Neutral8}
              //               sx={{ width: '317px', textAlign: 'center' }}
              //             >
              //               Add tasks to organize your project and track progress easily.
              //             </Typography>
              //           </Box>
              //         </Box>
              //         <CustomButton
              //           disabled={false}
              //           onClick={
              //             Object.values(selectedItems).reduce(
              //               (prev, val) => (val?.length ? prev + 1 : prev),
              //               overdueFilter ? 1 : 0,
              //             ) && !anchorEl
              //               ? handleClearAll()
              //               : () => {}
              //           }
              //           variant='outlined'
              //           color='secondary'
              //           style={{
              //             width: '150px',
              //             borderRadius: '14px',
              //             height: '48px',
              //             backgroundColor: zeplinColor.Brand1,
              //             gap: '16px',
              //             padding: '14px 16px',
              //           }}
              //           textStyle={{ color: zeplinColor.Neutral1 }}
              //           text={'Create Task'}
              //         />
              //       </Box>
              //     )}
              //   </Box>
              // </DndContext>
              <Box sx={{}}>
                <AsanaProjectTable
                  item={taskGrouped}
                  loading={loading}
                  setModalOpen={setModalTaskOpen}
                  assignee={assignee}
                  getTask={getTaskBySection}
                  drawerState={drawerState}
                  setDrawerState={setDrawerState}
                  filter={
                    Object.values(selectedItems).reduce(
                      (prev, val) => (val?.length ? prev + 1 : prev),
                      overdueFilter ? 1 : 0,
                    ) > 0
                  }
                />
              </Box>
            )}
          </Box>
          <CustomAlert
            open={copy || error ? true : false}
            handleClose={handleClose}
            message={
              error ? (
                <CustomAlertContain
                  alert={error && 'Something went wrong'}
                  alertIcon={error && <img src='/assets/error.svg' width={24} height={24} />}
                  error={true}
                />
              ) : (
                alertMessage
              )
            }
            error={error ? true : false}
          />
        </Box>
        <AsanaAddProject
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          data={editedProject ? editedProject : selectedProject}
          // key={editedProject ? editedProject?.name : selectedProject?.id}
          getProjects={() => {}}
          setEditedProject={setEditedProject}
          setMessage={setMessage}
        />
        {modalTaskOpen === true && (
          <AsanaAddTask
            modalOpen={modalTaskOpen}
            setModalOpen={setModalTaskOpen}
            // data={selectedProject}
            // key={selectedProject?.id}
            getTask={() => {}}
            // setEditedProject={setEditedProject}
            setMessage={setMessage}
            status={status}
            priority={priority}
            // assignee={assignee}
          />
        )}
        <CustomAlert
          open={message ? true : false}
          handleClose={handleClose}
          message={
            <CustomAlertContain
              alert={message ? message : ''}
              alertIcon={
                message && message?.includes('successfully') ? (
                  <img src='/assets/checkmark-green.png' width={24} height={24} />
                ) : (
                  <img src='/assets/error.svg' width={24} height={24} />
                )
              }
              error={!message || message?.includes('successfully') ? false : true}
            />
          }
          error={!message || message?.includes('successfully') ? false : true}
        />
      </Box>
      <CustomModal handleClose={handleDeleteClose} open={openDeleteModal}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}
        >
          <CustomCard
            styles={{
              borderRadius: '14px',
              padding: '24px',
              backgroundColor: zeplinColor.Neutral1,

              // width: '312px',
              // height: '201px',
              boxShadow: 'rgba(0, 0, 0, 0.15)',
              // display: 'flex',
              // flexDirection: 'column',
              // justifyContent: 'space-between',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '32px',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '16px',
                }}
              >
                <Typography variant='heading3' color={zeplinColor.BasicBlack}>
                  Delete Project
                </Typography>
                <Typography variant='body2' color={zeplinColor.BasicBlack}>
                  Are you sure you want to delete this project?
                  <br /> This action cannot be undone, and all project
                  <br /> details will be permanently removed.
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',

                  gap: '16px',
                }}
              >
                <Box
                  onClick={() => {
                    handleDeleteClose();
                  }}
                  sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}
                >
                  <CustomCard
                    styles={{
                      borderRadius: '14px',
                      padding: '14px 32px',
                      backgroundColor: zeplinColor.Neutral1,
                      border: `1px solid ${zeplinColor.BasicBlack}`,
                      cursor: 'pointer',
                      // width: '312px',
                      // height: '183px',
                      display: 'flex',
                      justifyContent: 'center',
                      flex: 1,
                      // display: 'flex',
                      // flexDirection: 'column',
                      // justifyContent: 'space-between',
                    }}
                    aria-role='button'
                    aria-disable={loading}
                  >
                    <Typography variant='buttonMedium' color={zeplinColor.BasicBlack}>
                      Cancel
                    </Typography>
                  </CustomCard>
                </Box>
                <Box
                  onClick={() => {
                    handleDeleteClick();
                    handleDeleteClose();
                  }}
                  sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}
                >
                  <CustomCard
                    styles={{
                      borderRadius: '14px',
                      padding: '14px 32px',
                      backgroundColor: zeplinColor.Error,
                      cursor: 'pointer',
                      // border: `1px solid ${zeplinColor.BasicBlack}`,
                      // width: '312px',
                      // height: '183px',
                      display: 'flex',
                      justifyContent: 'center',
                      flex: 1,
                      // display: 'flex',
                      // flexDirection: 'column',
                      // justifyContent: 'space-between',
                    }}
                    aria-role='button'
                    aria-disable={loading}
                  >
                    <Typography
                      variant='buttonMedium'
                      color={zeplinColor.Neutral1}
                      sx={{ whiteSpace: 'nowrap', textAlign: 'center' }}
                    >
                      Delete
                    </Typography>
                  </CustomCard>
                </Box>
              </Box>
            </Box>
          </CustomCard>
          {/* {loading ? <CustomLoader /> : ''} */}
        </Box>
      </CustomModal>
    </>
  );
};

export default AsanaProjectDetails;
